import type { TFunction } from "i18next"

import type { ArchiveQuestion } from "../api/services.types.ts"

type Subject = "projectArchive" | "leadArchive"

/** The dialog's title and confirm label name what the user is actually giving up. */
export const archiveQuestionLabels = (
  question: ArchiveQuestion,
  subject: Subject,
  t: TFunction
) => {
  const meetings = question.pendingCommitments.length > 0
  const signatures = question.pendingSignatures.length > 0
  if (meetings && signatures) {
    return {
      title: t(`${subject}.commitments.title`),
      confirm: t("esign.archive.confirmBoth")
    }
  }
  if (signatures) {
    return {
      title: t("esign.archive.title"),
      confirm: t("esign.archive.confirm")
    }
  }
  return {
    title: t(`${subject}.commitments.title`),
    confirm: t(`${subject}.commitments.confirm`)
  }
}
